import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="writablestream" id="writablestream"></a>
    <h1 {...{
      "id": "windowwritablestream"
    }}>{`window.WritableStream`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/WritableStream"
      }}>{`Web APIs - WritableStream`}</a>{`  `}</p>
    <a name="new-writablestream-new" id="new-writablestream-new"></a>
    <h2 {...{
      "id": "writablestreamunderlyingsink-strategy"
    }}>{`WritableStream(underlyingSink, strategy)`}</h2>
    <p>{`Creates a new WritableStream object wrapping the provided underlying sink.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`WritableStream`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSink`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defines how the constructred stream object will behave.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSink.start(contorller)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called immediately when the object is constructed.              If this process is to be done asynchronously, it can return a promise to signal success or failure.              The controller parameter passed to this method is a WritableStreamDefaultController.              This can be used by the developer to control the stream during set up.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSink.write(chunk,controller)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called when a new chunk of data is ready to be written to the underlying sink.              It can return a promise to signal success or failure of the write operation.              The controller parameter passed to this method is a WritableStreamDefaultController.              This method will be called only after previous writes have succeeded,              and never after the stream is closed or aborted.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`underlyingSink.close(controller)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called if the app signals that it has finished writing chunks to the stream.              If this process is asynchronous, it can return a promise to signal success or failure.              This method will be called only after all queued-up writes have succeeded.              The controller parameter passed to this method is a WritableStreamDefaultController.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`strategy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defines a queuing strategy for the stream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`strategy.highWaterMark`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The total number of chunks that can be contained              in the internal queue before backpressure is applied.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`strategy.size(chunk)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates the size to use for each chunk, in bytes.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="writablestream-locked" id="writablestream-locked"></a>
    <h2 {...{
      "id": "locked--boolean"
    }}>{`locked : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Indicate whether the WritableStream is locked.`}</p>
    <a name="writablestream-abort" id="writablestream-abort"></a>
    <h2 {...{
      "id": "abortreason"
    }}>{`abort(reason)`}</h2>
    <p>{`Aborts the stream, signalling that the producer can no longer successfully write to the stream and
it's to be immediately moved to an error state, with any queued writes discarded.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="writablestream-close" id="writablestream-close"></a>
    <h2 {...{
      "id": "close"
    }}>{`close()`}</h2>
    <p>{`Closes the stream.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the stream is locked.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TypeError`}</inlineCode>{` thrown if the stream is closed or closing.`}</li>
    </ul>
    <a name="writablestream-getwriter" id="writablestream-getwriter"></a>
    <h2 {...{
      "id": "getwriter"
    }}>{`getWriter()`}</h2>
    <p>{`Returns a new WritableStreamDefaultWriter object and locks the stream to that object.
While the stream is locked, no other writer can be acquired until this one is released.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`WritableStreamDefaultWriter`}</inlineCode>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      